<template>
  <el-drawer v-model="model" :direction="props.direction" :size="anchoSidebar" @close="video_store.clear()">

    <template #header>
      <h5>{{ video.titulo.toUpperCase() || '' }}</h5>
    </template>

    <div class="d-flex justify-content-center flex-column align-items">

      <video :src="video.url" controls :autoplay="false"></video>
      <!-- <iframe v-if="video.url" :src="video.url" width="100%" height="500px" frameborder="0"
            allowfullscreen autoplay="false"></iframe> -->

      <!-- descripcion -->
      <div v-if="video.descripcion" class="mt-2">
        <h5 class="text-start">Descripción</h5>
        <div v-html="video.descripcion"></div>
      </div>
    </div>


  </el-drawer>
</template>

<script setup>

import useRootStore from '@/store/root';


import useAppStore from '@/store/app';
import useVideoStore from '@/store/video';


const root_store = useRootStore();
const app_store = useAppStore();
const { loading } = storeToRefs(root_store);
const { anchoSidebar } = storeToRefs(app_store);
const video_store = useVideoStore();
const {video} = storeToRefs(video_store);

const props = defineProps({
  direction:{
    type:String,
    default:'rtl'
  }
});

const model = defineModel({
  type:Boolean,
  default:false 
});

</script>